import { requireStates } from "util";
import Sidebar from "components/support/sidebar";
import Topbar from "components/support/topbar";

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);

const initialStates = [
  {
    name: "app.history",
    url: "/historico",
    abstract: true,
    views: {
      "sidebar@app": Sidebar,
      "topbar@app": Topbar
    },
    data: {
      navigation: {
        priority: 100,
        name: "Gerencial"
      },
      authorization: context =>
        context.user.permissions.includes("view_open_sales") ||
        context.user.permissions.includes("view_closed_sales") ||
        context.user.permissions.includes("view_cash_register_reports") ||
        context.user.permissions.includes("view_cash_register_sales")
    }
  }
];

const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/history/index.js